import React from 'react'
import { Rating } from 'react-simple-star-rating'
import { useField } from 'formik'
import { LabelProps } from '../styles'
import { InputProps, Box, Text } from '@chakra-ui/core'

type ConnectedRatingProps = {
  value?: number
  onChange?: (value: number) => void
  size?: number
  readonly?: boolean
} & LabelProps &
  InputProps & {
    label?: string
    name: string
  }

const ConnectedRating: React.FC<ConnectedRatingProps> = ({
  label,
  name,
  value,
  onChange = () => {
    return
  },
  size = 24,
  readonly = false,
  ...rest
}) => {
  const [field, meta, helpers] = useField(`${name}.rating`)
  const handleRatingChange = (ratingValue: number) => {
    helpers.setValue(ratingValue)
    onChange(ratingValue)
  }

  return (
    <Box width="100%" mr={rest.mr} ml={rest.ml} mt={rest.mt} mb={rest.mb}>
      {label && (
        <Text fontSize="sm" mb={2}>
          {label}
        </Text>
      )}

      <Rating
        initialValue={field.value || value || 0}
        readonly={readonly}
        onClick={handleRatingChange}
        size={size}
        showTooltip
        tooltipDefaultText="Rate this"
        SVGstyle={{ display: 'inline' }}
        tooltipStyle={{
          fontSize: '12px',
          padding: '5px',
          backgroundColor: 'rgba(0, 0, 0, 0.7)',
          color: 'white',
          borderRadius: '4px'
        }}
      />

      {meta.touched && meta.error ? (
        <Text color="red.500" fontSize="xs">
          {meta.error}
        </Text>
      ) : null}
    </Box>
  )
}

export default ConnectedRating
